export default "__VITE_ASSET__D4I$6I4K__"